import { makeStyles } from "@material-ui/core/styles";
import { DateInput, NumberInputEx } from "components/inputs";
import { envSettings } from "core/EnvSettings";
import { RecordContextProvider } from "ra-core";
import React, { useEffect, useRef } from "react";
import { Filter, TextInput, useListContext, useTranslate } from "react-admin";

import { OperationModeToggleFilter } from "../../PickingList/components/OperationModeToggleFilter";

const useStyles = makeStyles({
	filterRoot: {
		"&.scanner-mode": {
			"& .MuiFormControl-root:not(:first-child)": {
				pointerEvents: "none",
				opacity: 0.5,
			},
			'& button[aria-label="Add filter"]': {
				pointerEvents: "none",
				opacity: 0.5,
			},
		},
	},
});

export const PalletsFilters = ({
	operationMode,
	setOperationMode,
	isSelectionMode,
	isOutgoingPlukk,
	isScannerMode,
	canScanToCreatePallet,
	record,
	...props
}) => {
	const classes = useStyles();
	const { setFilters, displayedFilters, hideFilter, filterValues } = useListContext();
	const translate = useTranslate();
	const isScannerOnlyMode = !envSettings.REACT_APP_FF_COMBINED_SCANNER_MANUAL_MODE && isScannerMode;

	const displayedFiltersRef = useRef(displayedFilters);
	displayedFiltersRef.current = displayedFilters;
	const filterValuesRef = useRef(filterValues);
	filterValuesRef.current = filterValues;

	useEffect(() => {
		if (isScannerOnlyMode) {
			Object.keys(displayedFiltersRef.current).forEach((filterName) => {
				if (filterName !== "order_id") {
					hideFilter(filterName);
				}
			});

			const orderId = filterValuesRef.current?.order_id || props.filterDefaultValues?.order_id;
			setFilters({ order_id: orderId }, {});
		}
	}, [isScannerOnlyMode, hideFilter, setFilters, props.filterDefaultValues]);

	return (
		<RecordContextProvider value={{}}>
			<Filter
				{...props}
				className={`${classes.filterRoot} ${isScannerOnlyMode ? "scanner-mode" : ""}`}
			>
				{!envSettings.REACT_APP_FF_COMBINED_SCANNER_MANUAL_MODE && (
					<OperationModeToggleFilter
						operationMode={operationMode}
						setOperationMode={setOperationMode}
						disabled={isOutgoingPlukk && !isSelectionMode}
						canScanToCreatePallet={canScanToCreatePallet}
						alwaysOn
					/>
				)}

				<TextInput
					label={translate("tab.pallets.sscc")}
					source="sscc"
					alwaysOn
					disabled={isScannerOnlyMode}
				/>
				<TextInput
					label={translate("tab.pallets.sscc_original")}
					source="sscc_original"
					disabled={isScannerOnlyMode}
				/>
				<TextInput
					source="id"
					label={translate("tab.pallets.pallet_id")}
					parse={(value) => (value ? [value] : undefined)}
					format={(value) => (Array.isArray(value) ? value[0] : value)}
					alwaysOn
					disabled={isScannerOnlyMode}
				/>
				<TextInput label={translate("tab.pallets.gtin")} source="gtin" />
				<DateInput
					label={translate("tab.pallets.production_datetime")}
					source="production_datetime"
				/>
				<DateInput
					label={translate("tab.pallets.expiration_datetime")}
					source="expiration_datetime"
				/>
				<NumberInputEx
					type="digits"
					label={translate("tab.pallets.external_id")}
					source="ext_id"
					alwaysOn
					disabled={isScannerOnlyMode}
				/>
				<TextInput label={translate("tab.pallets.product_number")} source="product_number" />
				<TextInput label={translate("tab.pallets.product_name")} source="product_name" />
				<TextInput label={translate("tab.pallets.batch_number")} source="batch_number" />
				<TextInput label={translate("tab.pallets.lot_number")} source="lot_number" />
				<TextInput label={translate("tab.pallets.packing_station")} source="packing_station" />
				{isOutgoingPlukk && (
					<TextInput
						label={translate("tab.pallets.incoming_order_ref")}
						source="incoming_order_ref"
					/>
				)}
			</Filter>
		</RecordContextProvider>
	);
};
